module.exports = __webpack_public_path__ + "842c17344820cbb0fb346cd600fbae7f.png";